import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import ConditionalWrapper from '@/components/ui/custom/ConditionalWrapper';
import { Tooltip } from '@/components/ui/custom/dataDisplay/Tooltip';
import { Badge, Button } from '@/components/ui/daisy';
import { Breakpoints } from '@/utils/Breakpoint';
import { PlusIcon } from '@heroicons/react/24/outline';
import { useMediaQuery } from 'react-responsive';

type CardAddContentButtonProps = {
  label: string;
  count?: number;
  isLoading?: boolean;
  onClick?: () => void;
};

const CardAddContentButton = ({
  label,
  count = 0,
  isLoading,
  onClick,
}: CardAddContentButtonProps) => {
  const isXl = useMediaQuery({ minWidth: Breakpoints.xl });

  return (
    <ConditionalWrapper condition={!isXl} wrapper={<Tooltip text={label} />}>
      <Button
        color="primary"
        variant={!count ? 'dash' : 'soft'}
        size="sm"
        onClick={onClick}
        disabled={isLoading}
      >
        <PlusIcon className="w-4 h-4" />
        {isXl && label}
        <ConditionalRenderer condition={count}>
          <Badge color="primary" size="xs">
            {count}
          </Badge>
        </ConditionalRenderer>
      </Button>
    </ConditionalWrapper>
  );
};

export default CardAddContentButton;
